import './wio.common';
import languagesBox from './features/language-box';

languagesBox('hover');
